module.exports = __webpack_public_path__ + "static/media/Chevron.7661d461.svg";